

















import { defineComponent } from "@vue/composition-api";
import { RunScene } from "@/components.run/run-scene";
import { getProps } from "../../ts/NodeComponent";

type SceneParams = {};

export default defineComponent({

	emits:[ "end", "previous" ],
	components:{
		RunScene
	},
	props:getProps<SceneParams>(),
	setup(_, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});

